<template>
  <v-container>
    <v-row>
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"/>
      <v-col>
        <v-card>
          <!-- Box Body -->
          <v-card-text>
            <v-row>
              <v-col cols="12" md="8">
                <v-text-field
                  label="Influencer Account"
                  v-model="userAccount"
                  placeholder="username or url"
                  outlined
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="6" md="4">
                <v-select
                  solo
                  :items="platformList"
                  item-value="value"
                  item-text="text"
                  v-model="selectedPlatform"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="download">Download(PDF)</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// import moment from 'moment';
import influencerAPIs from '../Influencer/influencerAPIs';
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  name: 'InfluencerSocialData',
  components: {
    Loading
  },
  data() {
    return {
      selectedPlatform: 'instagram',
      platformList: [
        {
          text: 'Instagram',
          value: 'instagram'
        },
        {
          text: 'TikTok',
          value: 'tiktok'
        },
        {
          text: 'YouTube',
          value: 'youtube'
        }
      ],
      userAccount: '',
      isLoading: false
    };
  },
  computed: {},
  watch: {},
  methods: {
    download() {
      if (this.userAccount.length > 0) {
        this.isLoading = true;
        influencerAPIs
          .downloadAudienceReportByInstagramHandle(this.userAccount, this.selectedPlatform)
          .then(() => {
            this.isLoading = false;
            this.userAccount = '';
          })
          .catch(() => {
            this.isLoading = false;
            this.$swal({
              title: 'Error',
              text: 'Something went wrong',
              type: 'error'
            });
          });
      } else {
        this.$swal({
          title: 'Empty Instagram handle',
          text: 'Please Input a handle',
          type: 'error'
        });
      }
    }
  },
  created() {}
};
</script>

<style>
#ig-handle {
  cursor: pointer;
}
.engagement {
  color: #81bee2;
  font-size: 20px;
}
.search-keyword-wrapper {
  /* padding-right: 25% !important;
  padding-left: 25% !important; */
}
.search-keyword {
  /* width: 120px; */
}
.v-dialog-wrapper {
  margin-top: 24px !important;
  padding: 0px;
}
.summary {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 500px;
  margin: auto;
  margin-bottom: 15px;
  margin-top: 15px;
}

.summary td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
</style>



// WEBPACK FOOTER //
// index.vue?14b67214